import api from './api';

export const menuService = {
  async getMenus() {
    const response = await api.get('/menus');
    return response.data;
  },

  async getMenu(id) {
    const response = await api.get(`/menus/${id}`);
    return response.data.data;
  },

  async createMenu(menuData) {
    const response = await api.post('/menus', menuData);
    return response.data.data;
  },

  async updateMenu(id, menuData) {
    const response = await api.put(`/menus/${id}`, menuData);
    return response.data.data;
  },

  async deleteMenu(id) {
    const response = await api.delete(`/menus/${id}`);
    return response.data.data;
  },

  async getMenuProteins({ page = 1, limit = 100 } = {}) {
    const response = await api.get('/menu-proteins', { params: { page, limit } });
    return response.data;
  },

  async getDeliveryOptions() {
    const response = await api.get('/delivery-options');
    return response.data;
  }
};